import React, { useEffect, useState } from "react";
import clsx from "clsx";
import {
  Box,
  Card,
  Grid,
  makeStyles,
  FormControl,
  Button,
  Paper,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Typography,
} from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { NavLink as RouterLink } from "react-router-dom";
import { kmMessages } from "src/constant/Messages";
import { DropzoneAreaBase } from "material-ui-dropzone";
import TableContainer from "@material-ui/core/TableContainer";
import KmFormEditTable from "src/components/common/KmFormEditTable";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import { apiEndpoints, apiPostRequest } from "src/utils/api/api";
import { useParams } from "react-router";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useNavigate } from "react-router-dom";
import { decode } from "js-base64";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
  formcontrol: {
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  paddingbottom: {
    paddingBottom: theme.spacing(1),
  },
  paddingtop: {
    paddingTop: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  rtepaper: {
    paddingBottom: theme.spacing(4),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  rtecontroll: {
    "& > ol": {
      paddingLeft: theme.spacing(4),
    },
  },
  statsuccess: {
    color: theme.palette.success.main,
  },
  inlineloader: {
    color: theme.palette.inlineloader.main,
  },
  attachmentdialog: {
    minWidth: 500,
  },
  img: {
    margin: "auto",
    display: "block",
    maxHeight: 60,
    maxWidth: "auto",
  },
}));

const attachmentColsEdit = [
  {
    label: "L.p.",
    isLp: true,
    isEditable: false,
    width: "5%",
  },
  {
    label: "",
    fieldName: "type",
    isEditable: false,
    width: "5%",
  },
  {
    label: "Nazwa",
    fieldName: "name",
    isEditable: true,
    width: "35%",
  },
  {
    label: "Status",
    fieldName: "status",
    isEditable: false,
    width: "35%",
    isHtml: false,
  },
];

const DocumentFormUpload = ({
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  ...rest
}) => {
  const classes = useStyles();

  const {
    parentFolderId,
    siblingDocumentId,
    siblingDocumentName,
  } = useParams();

  const [position, setPosition] = useState("end");
  const [access, setAccess] = useState("afterlogin");
  const navigate = useNavigate();

  const [attachments, setAttachments] = useState([]);
  const [uploadIndex, setUploadIndex] = useState(0);
  const [uploadCounter, setUploadCounter] = useState(0);

  useEffect(() => {
    if (uploadIndex < attachments.length) {
      enableGlobalLoader();
      attachments[uploadIndex].status = (
        <CircularProgress className={classes.inlineloader} color="primary" />
      );
      apiPostRequest(
        apiEndpoints.uploadFileDocument.path,
        {
          parentId: parentFolderId,
          fileName: attachments[uploadIndex].name,
          fileContent: attachments[uploadIndex].fileData.data,
          position: position,
          siblingId: siblingDocumentId,
          publicAccess: access === "public" ? true : false,
        },
        true
      )
        .then(() => {
          attachments[uploadIndex].noDelete = true;
          attachments[uploadIndex].status = (
            <Typography className={classes.statsuccess}>Zapisany</Typography>
          );

          setUploadIndex(uploadIndex + 1);
        })
        .catch((error) => {
          disableGlobalLoader();

          if (error.response && error.response.status === 403) {
            attachments[uploadIndex].status = (
              <Typography color="error">Błąd</Typography>
            );
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 8000,
              message:
                "Katalog nadrzędny nie jest dostępny publicznie. Dodawane dokumenty nie mogą mieć dostępu publicznego.",
            });
          } else {
            attachments[uploadIndex].status = (
              <Typography color="error">Błąd</Typography>
            );

            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 6000,
              message: kmMessages.error.document.document_upload_error.replaceAll(
                "{filename}",
                attachments[uploadIndex].name
              ),
            });
          }
        });
    } else {
      disableGlobalLoader();
      if (attachments.length > 0) {
        if (parentFolderId) {
          navigate("/dokumenty/" + parentFolderId);
        } else {
          navigate("/dokumenty");
        }
      }
    }
    return () => {};
  }, [uploadIndex, uploadCounter]);

  const onFormSubmit = () => {
    setUploadCounter(uploadCounter + 1);
  };

  const handleAttachmentsAdd = (newFiles) => {
    newFiles = newFiles.filter(
      (file) => !attachments.find((f) => f.resName === file.file.name)
    );

    let newAttachments = newFiles.map((file, index) => {
      return {
        id: `${new Date().getTime()}${index}`,
        type: <InsertDriveFileIcon />,
        attachmentType: "file",
        fileData: file,
        name: file.file.name,
        resName: file.file.name,
        state: "new",
        status: "Oczekiwanie na zapis",
      };
    });

    setAttachments([...attachments, ...newAttachments]);
  };

  const handlePositionChange = (event) => {
    setPosition(event.target.value);
  };

  const handleAccessChange = (event) => {
    setAccess(event.target.value);
  };

  return (
    <Card className={clsx(classes.root)}>
      <Box component="main">
        <Grid container className={classes.root}>
          <Grid item xs={12} elevation={2}>
            <FormControl component="fieldset" className={classes.formcontrol}>
              <FormLabel component="legend">Pozycja w katalogu:</FormLabel>

              <RadioGroup
                row
                aria-label="position"
                name="position"
                value={position}
                onChange={handlePositionChange}
              >
                <FormControlLabel
                  value="start"
                  control={<Radio color="primary" />}
                  label="na początku"
                />
                <FormControlLabel
                  value="end"
                  control={<Radio color="primary" />}
                  label="na końcu"
                />
                {siblingDocumentId ? (
                  <FormControlLabel
                    value="afterdoc"
                    control={<Radio color="primary" />}
                    label={
                      siblingDocumentName
                        ? `za '${decode(siblingDocumentName)}'`
                        : "za wskazanym"
                    }
                  />
                ) : (
                  <></>
                )}
              </RadioGroup>
            </FormControl>
            {/* <FormControl
              component="fieldset"
              className={classes.formcontrol}
              fullWidth
            >
              <FormLabel component="legend">Dostęp:</FormLabel>
              <RadioGroup
                row
                aria-label="Dostęp do dokumentów"
                name="access"
                value={access}
                onChange={handleAccessChange}
              >
                <FormControlLabel
                  value="afterlogin"
                  control={<Radio color="primary" />}
                  label="po zalogowaniu"
                />
                <FormControlLabel
                  value="public"
                  control={<Radio color="primary" />}
                  label="publiczny"
                />
              </RadioGroup>
            </FormControl> */}
            <FormControl
              fullWidth
              className={classes.formcontrol}
              variant="outlined"
              label="Pliki"
            >
              <Box className={classes.paddingbottom}>
                <FormLabel for="attachmentsfileupload">Pliki:</FormLabel>
              </Box>

              <DropzoneAreaBase
                showAlerts={false}
                name="attachmentsfileupload"
                className={classes.fileUpload}
                previewText="Wybrane pliki:"
                filesLimit={15}
                maxFileSize={200 * 1024 * 1024}
                dropzoneText="Przeciągnij i upuść pliki lub kliknij"
                inputProps={{
                  title: "Dodaj pliki",
                  id: "attachmentsfileupload",
                }}
                showPreviews={false}
                showPreviewsInDropzone={false}
                showFileNamesInPreview={false}
                onAdd={handleAttachmentsAdd}
                getFileAddedMessage={(fileName) =>
                  `Plik ${fileName} został załadowany.`
                }
                getFileRemovedMessage={(fileName) =>
                  `Plik ${fileName} został usunięty.`
                }
                getFileLimitExceedMessage={() =>
                  `Nie można załadować więcej niż 1 pliku.`
                }
                getDropRejectMessage={(maxFileSize) =>
                  `Przekroczono maksymalny rozmiar ładowanego pliku.`
                }
              />

              <TableContainer component={Paper}>
                <KmFormEditTable
                  columns={attachmentColsEdit}
                  rows={attachments}
                  caption="Dokumenty"
                  setRows={setAttachments}
                />
              </TableContainer>
            </FormControl>

            <Box className={classes.paddingtop}>
              <Button
                color="primary"
                className={classes.button}
                component={RouterLink}
                to="/dokumenty"
              >
                Anuluj
              </Button>
              <Button
                color="primary"
                variant="contained"
                className={classes.button}
                endIcon={<SaveIcon />}
                onClick={() => onFormSubmit()}
                type="submit"
              >
                Zapisz
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Card>
  );
};
const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(null, mapDispatchToProps)(DocumentFormUpload);
